'use strict';

import React from 'react';
import flux from 'utils/flux';

var PartnerLinks = React.createClass({
    displayName: 'PartnerLinks',
    onClickHandler: (url, target) => {
        window.open(url, target);
    },
    render() {
        const {partnerLinks, licensing} = flux.getStore('app').getState().config.toJS();
        return (
            <div>
                {(!licensing) ?

                    <ul className="partner-links__list">
                        {(partnerLinks !== undefined ? partnerLinks : []).map((link, id) => {
                            let target = (link.target) ? link.target : '';
                            return (
                                <li key={id} className="partner-links__list__item">
                                    <button onClick={this.onClickHandler.bind(this, link.url, target)} title={link.title}>
                                        <span className="play-icon"/>
                                        {link.title}
                                    </button>
                                </li>
                            );
                        })}
                    </ul>

                : ''
                }
            </div>
        );
    }
});

module.exports = PartnerLinks;



// WEBPACK FOOTER //
// ./app/components/links/partnerLinks.jsx